module.exports = __webpack_public_path__ + "static/img/9.5bf5162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/9.png
// module id = MlcS
// module chunks = 0